import {
  RefObject,
  useLayoutEffect
}                                     from 'react';
import { RotScaleInterface }          from "../types";
import { getRotScaleFromCSSTranform } from '../utils';

const scaleDown = (el: HTMLElement) => {
  const params: RotScaleInterface = getRotScaleFromCSSTranform(el);
  if (!params) return;
  const {rotation, scale} = params;

  el.style.transform = `scale(${scale - 0.05},${scale - 0.05}`;
  el.style.transform += `rotate(${rotation}deg)`;
};

const scaleUp = (el: HTMLElement) => {
  const params: RotScaleInterface = getRotScaleFromCSSTranform(el);
  if (!params) return;
  const {rotation, scale} = params;
  if (!rotation) console.warn(el, 'No element for getting scale properties!!!');

  el.style.transform = `scale(${scale + 0.05},${scale + 0.05}`;
  el.style.transform += `rotate(${rotation}deg)`;
};

const useClickDown = (element: RefObject<HTMLElement>) => {

  useLayoutEffect(() => {
    const el = element.current;

    if (!el) return;
    const doDown = () => scaleDown(el);
    const doUp = () => scaleUp(el);

    el.addEventListener('mousedown', doDown);
    el.addEventListener('mouseup', doUp);
    return () => {
      el.addEventListener('mousedown', doDown);
      el.addEventListener('mouseup', doUp);
    }
  }, []);
};

export default useClickDown